import { render, staticRenderFns } from "./UserAddInformation.vue?vue&type=template&id=31985a2a&"
import script from "./UserAddInformation.vue?vue&type=script&lang=js&"
export * from "./UserAddInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserAddInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserAddInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports